module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAd0lEQVQ4EaXBsQ3AMAzAMOn/o12NgScDJeUn+UmWCQeGyDLhwBBZJhwYIsuEA0NkmfAwZMLDEFkmPAyZ8DBElgkHhsgy4cAQWSYcGCLLhANDZJnwMGTCwxBZJjwMmfAwRJYJB4bIMuHAEFkmHBgiy4QDQ+Qn+ekDPPhQFT9RKGwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_score_08.png
// module id = 241
// module chunks = 0